import dynamic from 'next/dynamic';
import fetcher from 'lib/fetcher';
import { MetaHead } from 'components/MetaHead/MetaHead';
import { HeaderWithOptions } from 'components/Header';
import { Footer } from 'components/Footer';
import BottomNavigationMap from 'components/BottomNavigation/BottomNavigationMap';

const LegalDoc = dynamic(
  () => import('components/LegalDoc').then((mod) => mod.LegalDoc),
  {
    ssr: true,
  },
);

import type { Document } from '@contentful/rich-text-types';

interface PageProps {
  data?: { document: { 'de-DE': Document } };
}

export default function Page({ data }: PageProps): JSX.Element {
  const germanDocument = data?.document['de-DE'];

  return (
    <>
      <MetaHead follow={false} index={false} />
      <HeaderWithOptions hasLoginLink hasNavigationMenu hasPhoneBox={false} />
      <LegalDoc document={germanDocument} />
      <BottomNavigationMap />
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const data = await fetcher('https://legal-docs.smava.de/fullBankList.json');

  return {
    props: { data },
    revalidate: 3600, // 1 hour
  };
}
